import { GoalPayoutDto } from '../../payout';
import { ScoringDto } from '../../scoring';
import { GoalDto } from './goal.dto';

export interface GoalFindResponseDto extends GoalDto {
  scoring: ScoringDto | null;
  payoutRequest: GoalPayoutDto | null;
}
